"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BILLING_DOMAIN = void 0;
exports.BILLING_DOMAIN = "billing";
